import fetch from '../../lib/wrappedFetch'
import config from '../../config'

class ActivitiesService {
  fetchLatestCustomerActivities = () => {
    return fetch(config.config.endpointUrls.fetchLatestCustomerActivities(), {
      method: 'GET'
    })
  }
  fetchActivities = (params) => {
    return fetch(config.config.endpointUrls.fetchActivities(params), {
      method: 'GET'
    })
  }
}

export default new ActivitiesService()



// WEBPACK FOOTER //
// ../src/services/activitiesService/activitiesService.js